import { Dropdown } from 'antd';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxOverlay } from 'components/RevxOverlay';
import {
  Text,
  TextHeavy,
  Title,
  UnderlineText,
} from 'components/RevxTypography';
import { UserContactAddress } from 'domains/orgDomain';
import { addressTranslator } from 'utils/address';
import './ContactLink.less';
import NameBadge from './NameBadge';

const ContactLink = ({ userContact }: { userContact: UserContactAddress }) => {
  return (
    <Dropdown
      trigger={['click']}
      placement="bottomCenter"
      align={{ offset: [15, -20] }}
      overlay={
        <RevxOverlay style={{ padding: 12 }}>
          <div className="contact-link-overlay">
            <RevxFlexLayout className="contact-link-overlay-header">
              <NameBadge size="large" name={userContact.fullName} />
              <Title>{userContact.fullName}</Title>
            </RevxFlexLayout>
            <div className="contact-link-overlay-detail">
              <RevxFlexLayout align="stretch">
                <TextHeavy className="workspace-item-content-row-title contact-link-overlay-label">
                  Email:
                </TextHeavy>
                <Text className="workspace-item-content-row-t">
                  {userContact.email || ''}
                </Text>
              </RevxFlexLayout>
              <RevxFlexLayout align="stretch">
                <TextHeavy className="workspace-item-content-row-title contact-link-overlay-label">
                  Company:
                </TextHeavy>
                <Text className="workspace-item-content-row-t">
                  {userContact.company || ''}
                </Text>
              </RevxFlexLayout>
              <RevxFlexLayout align="stretch">
                <TextHeavy className="workspace-item-content-row-title contact-link-overlay-label">
                  Phone:
                </TextHeavy>
                <Text className="workspace-item-content-row-t">
                  {userContact.phoneNumber || ''}
                </Text>
              </RevxFlexLayout>
              <RevxFlexLayout align="stretch">
                <TextHeavy className="workspace-item-content-row-title contact-link-overlay-label">
                  Address:
                </TextHeavy>
                <Text className="workspace-item-content-row-t">
                  {addressTranslator.getCompactAddress(userContact) || ''}
                </Text>
              </RevxFlexLayout>
            </div>
          </div>
        </RevxOverlay>
      }
    >
      <UnderlineText
        size="small"
        color="blue"
        className="workspace-item-content-row-t"
      >
        {userContact.fullName}
      </UnderlineText>
    </Dropdown>
  );
};

export default ContactLink;
